import type { TextFieldProps } from '@mui/material';
import { IconButton, InputAdornment, MenuItem, TextField } from '@mui/material';
import { XIcon } from '@phosphor-icons/react';
import { forwardRef } from 'react';

type ClearableSelectProps = {
  options: { value: string; label: string }[];
  onClear?: () => void;
} & TextFieldProps;

export const ClearableSelect = forwardRef<HTMLInputElement, ClearableSelectProps>(
  ({ options, value, onClear, disabled, slotProps, ...rest }, ref) => {
    const hasValue = value !== undefined && value !== null && String(value) !== '';

    return (
      <TextField
        select
        {...rest}
        ref={ref}
        disabled={disabled}
        value={value ?? ''}
        slotProps={{
          ...slotProps,
          input: {
            // eslint-disable-next-line @typescript-eslint/no-misused-spread
            ...slotProps?.input,
            endAdornment:
              hasValue && !disabled ? (
                <InputAdornment position="end" sx={{ mr: 1 }}>
                  <IconButton edge="end" onClick={onClear} size="small">
                    <XIcon />
                  </IconButton>
                </InputAdornment>
              ) : undefined,
          },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    );
  },
);
